module.exports = require("wix-location-frontend");